export default "__VITE_ASSET__102879ea__"